import { useState } from "react";
import { Icon } from "@iconify/react";
import { enqueueSnackbar } from "notistack";
import Modal1 from "../../../components/DIsplay/Modal/Modal1";
import Button1 from "../../../components/form/Button1";
import { formatMoney } from "../../../features/utils/formatMoney";
import { createWorldCup } from "./worldCupController";
import { buildWorldCupPayload, WORLD_CUP_TEAMS } from "./payload";

export default function ConfirmInitiateWorldCupModal({
  open,
  setOpen,
  prizePoolAmount,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    const res = await createWorldCup(buildWorldCupPayload(prizePoolAmount));
    setLoading(false);

    if (res.return) {
      enqueueSnackbar(res.msg, { variant: "success" });
      setOpen(false);
      onSuccess?.(res.data);
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
    }
  };

  return (
    <Modal1
      open={open}
      setOpen={setOpen}
      modalBorderRadius="rounded-2xl"
      config={{ bg: false, hideMobileClose: true }}
    >
      <div className="w-[min(100vw-2rem,440px)] overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="relative overflow-hidden bg-gradient-to-br from-[#0B3D91] via-[#1565C0] to-[#1E88E5] px-6 pb-8 pt-6 text-white">
          <div className="pointer-events-none absolute -right-6 -top-6 h-28 w-28 rounded-full bg-white/10" />
          <div className="pointer-events-none absolute -bottom-10 -left-4 h-24 w-24 rounded-full bg-white/10" />

          <button
            type="button"
            className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-white transition hover:bg-white/25"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            <Icon icon="mdi:close" className="text-lg" />
          </button>

          <div className="flex flex-col items-center gap-3 text-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/20 backdrop-blur-sm">
              <Icon icon="mdi:soccer" className="text-3xl" />
            </span>
            <div className="flex flex-col gap-1">
              <span className="text-xl font-bold tracking-tight">
                Initiate World Cup 2026
              </span>
              <span className="text-sm text-white/80">
                Review the prize pool before launching the tournament.
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-5 px-6 py-6">
          <div className="relative overflow-hidden rounded-2xl border-2 border-amber-200 bg-gradient-to-b from-amber-50 to-white p-5 text-center shadow-sm">
            <div className="pointer-events-none absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-amber-300 via-yellow-400 to-amber-300" />

            <div className="mb-3 flex items-center justify-center gap-2 text-amber-700">
              <Icon icon="mdi:trophy" className="text-xl" />
              <span className="text-xs font-bold uppercase tracking-[0.2em]">
                Prize Pool Amount
              </span>
            </div>

            <span className="block text-4xl font-extrabold tracking-tight text-[#0B3D91] sm:text-5xl">
              {formatMoney(prizePoolAmount)}
            </span>

            <span className="mt-2 block text-sm text-[#6D7C94]">
              This is the total prize pool players will compete for.
            </span>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="flex flex-col gap-1 rounded-xl border border-[#E7EDF5] bg-[#F8FAFD] px-4 py-3">
              <span className="text-xs font-medium uppercase tracking-wide text-[#6D7C94]">
                Tournament
              </span>
              <span className="text-sm font-semibold text-primary">
                FIFA World Cup 2026
              </span>
            </div>
            <div className="flex flex-col gap-1 rounded-xl border border-[#E7EDF5] bg-[#F8FAFD] px-4 py-3">
              <span className="text-xs font-medium uppercase tracking-wide text-[#6D7C94]">
                Teams
              </span>
              <span className="text-sm font-semibold text-primary">
                {WORLD_CUP_TEAMS.length} nations
              </span>
            </div>
          </div>

          <div className="flex items-start gap-3 rounded-xl border border-amber-100 bg-amber-50/80 px-4 py-3">
            <Icon
              icon="mdi:alert-circle-outline"
              className="mt-0.5 shrink-0 text-lg text-amber-600"
            />
            <span className="text-sm leading-relaxed text-amber-900">
              Once initiated, the game cannot be undone. Please confirm the
              prize pool amount above is correct.
            </span>
          </div>

          <div className="flex gap-3 pt-1">
            <Button1
              variant="outlined"
              type="button"
              className="flex-1"
              onClick={() => setOpen(false)}
            >
              Go Back
            </Button1>
            <Button1
              type="button"
              className="flex-1"
              loading={loading}
              onClick={handleConfirm}
            >
              Initiate Game
            </Button1>
          </div>
        </div>
      </div>
    </Modal1>
  );
}
